<template>
<dialog-wrapper
  :getter="getCallServerDialog && !showLoginDialog"
  :setter="SET_CALL_SERVER_DIALOG"
  :close="() => SET_CALL_SERVER_DIALOG(false)"
  apply-padding
>
  <template #body>
    <h2>
      {{ $vuetify.t('$vuetify.requestService.title') }}
    </h2>

    <h4 v-html="sent">
    </h4>

    <v-layout row wrap>
      <v-flex v-for="request in requests" :key="request.code" xs12 md6>
        <v-btn fill-height block color="accent" @click="sendRequest(request)" :class="{'contain-button': $vuetify.breakpoint.mdAndUp}">
          {{ _translate(request) }}
        </v-btn>
      </v-flex>
    </v-layout>
  </template>
</dialog-wrapper>
</template>

<script>
import get from 'lodash/get';

import { load } from 'recaptcha-v3'
import { mapGetters, mapMutations, mapActions } from 'vuex';

import { matchTranslation, formatTime } from "@/services/util.service"

import DialogWrapper from '@/components/Wrappers/DialogWrapper'

export default {
  extends: DialogWrapper,
  components: { DialogWrapper },

  data: () => ({
    sent: null
  }),
  computed: {
    requests() {
      return get(this.getStore, 'serviceRequestList', [])
    },

    ...mapGetters([ 'getCallServerDialog', 'getStore', 'getTableId', 'getCustomer', 'getAuthUser', 'isLoggedIn', 'showLoginDialog', 'allowAnonymousDineIn' ])
  },

  methods: {
    async sendRequest(request) {
      if (!this.isLoggedIn && !this.allowAnonymousDineIn) {
        this.showSnack({
          text: this.$vuetify.t('$vuetify.requestService.login'),
          color: 'error'
        })

        this.setLoginDialog(true)
        return
      }

      // We use reCAPTCHA to authenticate offline payments to avoid malicuous behaviour
      const recaptcha = await load('6LeG1m4rAAAAAEsvXtWYVz2wAzFCh5Fpd-4_urx2', { autoHideBadge: true, useEnterprise: true});
      if (!recaptcha || !recaptcha.siteKey) {
        this.SET_DIALOG_MESSAGE({
          title: "Error Occured",
          body: 'Captcha Error',
          message: 'Please, try again'
        })
        return
      }
      const CAPTCHA_ACTION = {
        PAY_ORDER: 'PAY_ORDER',
      };

      _paymentReq.captcha = await recaptcha.execute(CAPTCHA_ACTION.PAY_ORDER);

      this.sent = `${this.$vuetify.t('$vuetify.requestService.sent')}: ${this._translate(request)} (${formatTime(new Date())})`

      this.$api.post('servicerequest', {
          tableNo: this.getTableId,
          code: request.code,
          customerName: this.isLoggedIn ? this.getCustomer.firstName+' '+this.getCustomer.lastName : null,
          telephone: this.isLoggedIn ? this.getCustomer.telephone : null,
          captcha: captcha
      }, {
        headers: this.isLoggedIn ?  { 'userId': this.getAuthUser.id } : {}
      }).catch(error => {
        this.sent += `<br>Failed: ${get(error, 'response.data.errorMsg', '')}`
      })
    },

    _translate(obj) {
      return matchTranslation(get(obj, 'nameTranslations.translations', []))
    },

    ...mapMutations([ 'SET_CALL_SERVER_DIALOG', 'SET_DIALOG_MESSAGE', 'setLoginDialog' ]),
    ...mapActions([ 'showSnack' ])
  }
}
</script>

<style scoped>
  .contain-button {
    max-width: 90%;
    margin: 10px auto;
  }

  h2 {
    margin: 10px auto 20px;
  }
  h2, h4 {
    text-align: center;
  }
</style>
